/* eslint-disable no-console */
/* global KJUR,CryptoJS,Vue */
import '@mfec/testing/components/TefComsSpidSelect.ts';
import '@mfec/testing/components/TefComsLifecycleSelect.ts';
import '@mfec/testing/components/TefComsChannelSelect.ts';

const scenarios = [
  {
    value: 'legacy-real',
    label: 'Real Agent Token',
    description: 'You need to provide a real agent token.',
    deprecated: true,
  },
  {
    value: 'legacy-fake',
    label: 'Fake Agent Token',
    description: 'An agent token will be created on-the-fly based on the properties below.',
    deprecated: true,
  },
  {
    value: 'raitt-real',
    label: 'Real Access Token',
    description: 'You need to provide a real ForgeRock access token. This is simulating the integrating portal.',
    raitt: true,
  },
  {
    value: 'raitt-fake',
    label: 'Fake Access Token',
    description: `A fake access token will be created on-the-fly based on the properties below.
    This is simulating the integrating portal and bypassing ForgeRock.`,
    raitt: true,
  },
];

const propsQuery = [
  { name: 'lifecycle', type: 'string', defaultValue: 'webAppRegistrationProcess' },
  { name: 'mode', type: 'string', defaultValue: '' },
  { name: 'scenario', type: 'string', defaultValue: scenarios[0].value },
  { name: 'agenttoken', type: 'string', defaultValue: '' },
  { name: 'gatewaytoken', type: 'string', defaultValue: '' },
  { name: 'accesstoken', type: 'string', defaultValue: '' },
  { name: 'spId', type: 'string', defaultValue: 'SP901' },
  { name: 'registerId', type: 'string', defaultValue: '0815' },
  { name: 'lcId', type: 'string', defaultValue: '4711' },
  { name: 'agentname', type: 'string', defaultValue: 'fakeagent' },
  { name: 'agentroles', type: 'string', defaultValue: 'Contract Manager' },
  { name: 'usertype', type: 'string', defaultValue: '' },
  { name: 'channel', type: 'string', defaultValue: '' },
  { name: 'vonr', type: 'string', defaultValue: '' },
  {
    name: 'apiuri',
    type: 'string',
    defaultValue:
      window.location.protocol === 'http:' && window.location.hostname.indexOf('local') >= 0
        ? `http://${window.location.hostname}:3000`
        : 'https://ict.high.apigw-test.aws.de.pri.o2.com/gateway/coms4cs-ict/v2',
  },
  { name: 'occluri', type: 'string', defaultValue: 'https://dev-library.telefonica.de/epos' },
  { name: 'tefOne', type: 'string', defaultValue: '' },
  { name: 'tefOneEnv', type: 'string', defaultValue: 'main' },
  { name: 'stylecontext', type: 'string', defaultValue: '' },
  { name: 'consentwhitelist', type: 'string', defaultValue: '' },
  { name: 'readonly', type: 'boolean', defaultValue: false },
  { name: 'references', type: 'string', defaultValue: '' },
  { name: 'showReferences', type: 'boolean', defaultValue: false },
  { name: 'showVersions', type: 'boolean', defaultValue: false },
  { name: 'isExistingRegister', type: 'boolean', defaultValue: false },
  { name: 'isNewCustomer', type: 'boolean', defaultValue: false },
  { name: 'nestInsideShadowRoot', type: 'boolean', defaultValue: false },
  { name: 'traceid', type: 'string', defaultValue: '' },
];

const propsLocalStorage = [{ name: 'clearSessionStorage', defaultValue: true }];

const shortcuts = {
  mode: [
    { value: '', label: 'none' },
    { value: 'overview', label: 'overview' },
    { value: 'buttons', label: 'buttons' },
  ],
  apiuriGateway: [
    { value: 'https://ict.high.apigw-test.aws.de.pri.o2.com/gateway/coms4cs/v2', label: 'ict' },
    { value: 'https://e2e2.high.apigw-test.aws.de.pri.o2.com/gateway/coms4cs/v2', label: 'e2e2' },
    { value: 'https://e2e1.high.apigw-test.aws.de.pri.o2.com/gateway/coms4cs/v2', label: 'e2e1' },
    { value: 'https://prod.high.apigw-prod.aws.de.pri.o2.com/gateway/coms4cs/v2', label: 'prod' },
  ],
  apiuriDirect: [
    { value: 'http://localhost:3000', label: 'localhost' },
    { value: 'https://main-api-consent.high.coms-dev.aws.de.pri.o2.com', label: 'main' },
    { value: 'https://ict-api-consent.high.coms-dev.aws.de.pri.o2.com', label: 'ict' },
    { value: 'https://e2e2-api-consent.high.coms-dev.aws.de.pri.o2.com', label: 'e2e2' },
    { value: 'https://e2e1-api-consent.high.coms-dev.aws.de.pri.o2.com', label: 'e2e1' },
    { value: 'https://api-consent.high.coms-prod.aws.de.pri.o2.com', label: 'prod' },
  ],
  occluriDev: [
    { value: 'https://dev-library.telefonica.de/1', label: 'o2' },
    { value: 'https://dev-library.telefonica.de/2', label: 'Blau' },
    { value: 'https://dev-library.telefonica.de/epos', label: 'epos' },
    { value: 'https://dev-library.telefonica.de/salesforce', label: 'salesforce' },
  ],
  occluriProd: [
    { value: 'https://library.telefonica.de/1', label: 'o2' },
    { value: 'https://library.telefonica.de/2', label: 'Blau' },
    { value: 'https://library.telefonica.de/epos', label: 'epos' },
    { value: 'https://library.telefonica.de/salesforce', label: 'salesforce' },
  ],
  tefOne: [
    { value: 'o2', label: 'o2' },
    { value: 'blau', label: 'Blau' },
    { value: 'retail', label: 'Retail' },
  ],
  tefOneEnv: [
    { value: 'main', label: 'main' },
    { value: 'staging', label: 'staging' },
  ],
  stylecontext: [
    { value: '', label: 'none' },
    { value: 'shop', label: 'shop' },
    { value: 'selfcare', label: 'selfcare' },
  ],
  gatewaytoken: [
    {
      label: 'main',
      value:
        'eyJ4NXQiOiJNell4TW1Ga09HWXdNV0kwWldObU5EY3hOR1l3WW1NNFpUQTNNV0kyTkRBelpHUXpOR00wWkdSbE5qSmtPREZrWkRSaU9URmtNV0ZoTXpVMlpHVmxOZyIsImtpZCI6Ik16WXhNbUZrT0dZd01XSTBaV05tTkRjeE5HWXdZbU00WlRBM01XSTJOREF6WkdRek5HTTBaR1JsTmpKa09ERmtaRFJpT1RGa01XRmhNelUyWkdWbE5nX1JTMjU2IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiJVLTY3Mi1Db01TX1N1YkBjYXJib24uc3VwZXIiLCJhdXQiOiJBUFBMSUNBVElPTiIsImF1ZCI6WyJPbFZDWDVwVXJyVWJBb2ZmTlhtVm1BQmQ5TTRhIiwiaHR0cDpcL1wvb3JnLndzbzIuYXBpbWd0XC9nYXRld2F5Il0sIm5iZiI6MTYyMTI0NzA5OSwiYXpwIjoiT2xWQ1g1cFVyclViQW9mZk5YbVZtQUJkOU00YSIsInNjb3BlIjoiZGVmYXVsdCIsImlzcyI6Imh0dHBzOlwvXC9pY3QuYXBpZ3ctYXdzLmRlLnByaS5vMi5jb206NDQzXC9vYXV0aDJcL3Rva2VuIiwiZXhwIjo5MjIzMzcyMDM2ODU0Nzc1LCJpYXQiOjE2MjEyNDcwOTksImp0aSI6IjdiOGY0NmNiLTllZDMtNGRiZi04MWRjLTg3NzRhZGQ3NDg2MiJ9.bFBxhz0ZDUTqbdCHHWyw318ngcsAJNLSmduT19XlysH8XdG11pLHwpTa30lbpJgCWq63QkYFm_5qIeHTOEyUM525TQs6yoAoBzVuMS2lfn3wHQmNZlQkGS60dhOn8bNKSVUJLuHe-sIYZs6k_lV6snpUnVCS-DOHj_TH_rskUKIeCXt5SVTykN3rZFJjqckxg1heIjZPwdK1N8EbdFO5LLLH9Xgl66y-7y0t-f_eEUI6WxM_Yrt98OEnrCsGFDXhqKv1-stxNec8M9Hzy0KEY48DW27osRDnTtf1FlSZbLsSWasgr1vyQCfbuay-XUC0MkEs9NhQy_mbvf8JzduWpg',
    },
    {
      label: 'ict',
      value:
        'eyJ4NXQiOiJNell4TW1Ga09HWXdNV0kwWldObU5EY3hOR1l3WW1NNFpUQTNNV0kyTkRBelpHUXpOR00wWkdSbE5qSmtPREZrWkRSaU9URmtNV0ZoTXpVMlpHVmxOZyIsImtpZCI6Ik16WXhNbUZrT0dZd01XSTBaV05tTkRjeE5HWXdZbU00WlRBM01XSTJOREF6WkdRek5HTTBaR1JsTmpKa09ERmtaRFJpT1RGa01XRmhNelUyWkdWbE5nX1JTMjU2IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiJVLTY3Mi1Db01TX1N1YkBjYXJib24uc3VwZXIiLCJhdXQiOiJBUFBMSUNBVElPTiIsImF1ZCI6WyJPbFZDWDVwVXJyVWJBb2ZmTlhtVm1BQmQ5TTRhIiwiaHR0cDpcL1wvb3JnLndzbzIuYXBpbWd0XC9nYXRld2F5Il0sIm5iZiI6MTYyMTI0NzI4MSwiYXpwIjoiT2xWQ1g1cFVyclViQW9mZk5YbVZtQUJkOU00YSIsInNjb3BlIjoiZGVmYXVsdCIsImlzcyI6Imh0dHBzOlwvXC9pY3QuYXBpZ3ctYXdzLmRlLnByaS5vMi5jb206NDQzXC9vYXV0aDJcL3Rva2VuIiwiZXhwIjo5MjIzMzcyMDM2ODU0Nzc1LCJpYXQiOjE2MjEyNDcyODEsImp0aSI6ImYyOGRjYmIzLTQ0YjUtNGI3OS04MDg3LTc2NzRkNjRmNGRmYyJ9.ANirRsqqn_tl7kYhcUW4816aYioauaGVaVjfXA9RsHTXwoao_ffDJS-mFAiFRdOHelDRtMFH0DQUFfpb4ODOREhfqR5yJYz-UhEVKh1Ub-y3WZ3f3M3dLQNteIOzQjfBsiMFtTc-oJVLb89_p6q-iXiAT4CPBuMCjInvKvIZqeN7vAvT4v9NolbrkvD0rVS2Im2l_f1QPksSnTkB2Kvhuy21NkFM1vYXygteRGB9J9X6TSGM52gJAMJdxu4aiVFvwajkWjQ0IZgGYxiOJjqYRqR88UpWwrps2bydBbAYt0XB--M-HygttF7Z4HFUcLcL9LnDSEDi8U02oQ6yqn0sAg',
    },
    {
      label: 'e2e2',
      value:
        'eyJ4NXQiOiJNell4TW1Ga09HWXdNV0kwWldObU5EY3hOR1l3WW1NNFpUQTNNV0kyTkRBelpHUXpOR00wWkdSbE5qSmtPREZrWkRSaU9URmtNV0ZoTXpVMlpHVmxOZyIsImtpZCI6Ik16WXhNbUZrT0dZd01XSTBaV05tTkRjeE5HWXdZbU00WlRBM01XSTJOREF6WkdRek5HTTBaR1JsTmpKa09ERmtaRFJpT1RGa01XRmhNelUyWkdWbE5nX1JTMjU2IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiJVLTY3Mi1Db01TX1N1YkBjYXJib24uc3VwZXIiLCJhdXQiOiJBUFBMSUNBVElPTiIsImF1ZCI6IjdVM0RTSmhaZkxzN1VzWkRPTWpESnlsdFI4NGEiLCJuYmYiOjE2MjEyNDc3MDIsImF6cCI6IjdVM0RTSmhaZkxzN1VzWkRPTWpESnlsdFI4NGEiLCJzY29wZSI6ImRlZmF1bHQiLCJpc3MiOiJodHRwczpcL1wvZTJlMi5hcGlndy1hd3MuZGUucHJpLm8yLmNvbTo0NDNcL29hdXRoMlwvdG9rZW4iLCJleHAiOjkyMjMzNzIwMzY4NTQ3NzUsImlhdCI6MTYyMTI0NzcwMiwianRpIjoiMmU3MGZkY2MtYTljNS00YmJhLWEwODYtZDQyMWY1ZTk2YjhiIn0.oZJvo7MRtFgFbSXOv0qirW9kyUtUdc94_p9rnK9wAOK86F_eB-0XWq_cnDF8ZLiOEj2Gr61o6J2Z7HLBueBPriQa98zgT-e15OFQgfVytb1IVseQBQc3-_l8KAGDgXvwg1oxKSsM8EXHxOdUBTh3qj6Oiz0i2zHObikS62labc2mRoOA4lef1wFSgv0am4tQdMPiLcjcaYUmrP0agwS8qwaVZgg3BlfOeYA-rh8GO5p1GrvUrukS3Xb9xdraCzZyHa58WNaZ12jSbkS5QkXmVnqsZL1exCJWVUOzxxoJgLdVWtZlp0egtQhicZEMAq_MCVJ9Aj3SZ2iM4O4ZEaQD_g',
    },
  ],
};

function createJwt(payload, secret = 'ach-wie-gut-dass-niemand-weiss-9') {
  console.info('token payload is', payload);
  const header = { alg: 'HS256', typ: 'JWT', kid: 'test' };
  return KJUR.jws.JWS.sign(header.alg, JSON.stringify(header), JSON.stringify(payload), secret);
}

function createComs({
  scenario,
  agenttoken,
  gatewaytoken,
  accesstoken,
  apiuri,
  occluri,
  stylecontext,
  spId,
  registerId,
  lcId,
  readonly,
  lifecycle,
  mode,
  agentname,
  agentroles,
  consentwhitelist,
  channel,
  usertype,
  vonr,
  references,
  showReferences,
  showVersions,
  isExistingRegister,
  isNewCustomer,
  nestInsideShadowRoot,
  traceid,
  clearSessionStorage,
}) {
  if (clearSessionStorage) {
    window.sessionStorage.clear();
  }

  const coms = document.createElement('tef-coms4cs');
  const setAttributes = (attrs) =>
    Object.entries(attrs)
      .filter(([, value]) => value) // ignore '', false, undefined
      .forEach(([name, value]) => coms.setAttribute(name, value));
  // set scenario-independent attributes
  setAttributes({
    id: 'consents',
    lifecycle,
    mode,
    apiuri,
    occluri,
    stylecontext,
    consentwhitelist,
    channel,
    usertype,
    vonr,
    references,
    showReferences,
    showVersions,
    traceid,
    isExistingRegister,
    isNewCustomer,
  });
  // set scenario-specific attributes
  if (scenario === 'legacy-real') {
    setAttributes({
      gatewaytoken,
      agenttoken,
    });
  }
  if (scenario === 'legacy-fake') {
    const token = createJwt({
      iss: 'epos.telefonica.de',
      sub: agentname,
      aud: 'coms.telefonica.de',
      spId,
      ...(registerId ? { registerId } : {}),
      ...(lcId ? { lcId } : {}),
      readonly,
      iat: Math.floor(Date.now() / 1000),
      exp: Math.floor(Date.now() / 1000) + 60 * 60, // 1 hour
    });
    const aesKeyBase64 = 'NHhxbmt1MzRnY24yaXV3eGdyeGtqY3dnaDRuc3V3eWo='; // must decode to 16 or 32 bytes
    const ivBase64 = '5D9r9ZVzEYYgha93/aUK2w==';
    const key = CryptoJS.enc.Base64.parse(aesKeyBase64); // must be 16 or 32 bytes !!
    const iv = CryptoJS.enc.Base64.parse(ivBase64); // must be 16 bytes !!
    const encrypted = CryptoJS.AES.encrypt(token, key, {
      mode: CryptoJS.mode.CBC,
      iv,
    });
    setAttributes({
      gatewaytoken,
      agenttoken: encrypted,
    });
  }
  if (scenario === 'raitt-fake') {
    // new ForgeRock token format Jan 2023
    const roles = (agentroles || '')
      .split(/[,;]/)
      .map((s) => s.trim())
      .filter((s) => s);
    const token = createJwt({
      iss: 'https://fake.issuer.for.coms.simulator.telefonica.de',
      sub: agentname ?? 'fake-agent',
      username: agentname ?? 'fake-agent',
      spID: spId,
      domainModel: lcId
        ? roles.map((role) => ({
            customerAccountId: lcId,
            role,
          }))
        : [],
      scope: ['openid'], // oidc "u-672:trusted"?
    });
    window.altfetch = async (uri, options = {}) => {
      const { headers = {}, ...other } = options;
      return window.fetch(uri, {
        ...other,
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      });
    };
    setAttributes({
      spId,
      registerId,
      lcId,
      fetch: 'altfetch', // ref by name
    });
  }
  if (scenario === 'raitt-real') {
    window.altfetch = async (uri, options = {}) => {
      const { headers = {}, ...other } = options;
      return window.fetch(uri, {
        ...other,
        headers: {
          ...headers,
          Authorization: `Bearer ${accesstoken}`,
        },
      });
    };
    setAttributes({
      spId,
      registerId,
      lcId,
      fetch: 'altfetch', // ref by name
    });
  }

  const mfeHost = document.getElementById('mf');

  if (nestInsideShadowRoot) {
    const host = document.createElement('span');
    const shadow = host.attachShadow({ mode: 'open' });
    host.classList.add('fake-shadow-dom-from-integrator');
    host.style = 'border: 4px dotted Red; display: block; padding: 10px;';
    shadow.appendChild(coms);
    mfeHost.appendChild(host);
  } else {
    mfeHost.appendChild(coms);
  }

  return coms;
}

const components = {
  deprecated: {
    template: /* html */ `
      <span class="badge bg-danger rounded-pill">deprecated</span>
    `,
  },
  raitt: {
    template: /* html */ `
      <span class="badge bg-primary rounded-pill">new raitt</span>
    `,
  },
  attribute: {
    template: /* html */ `
      <span class="badge bg-warning rounded-pill">attribute</span>
    `,
  },
  workaround: {
    template: /* html */ `
      <span class="badge bg-dark rounded-pill">workaround</span>
    `,
  },
  testing: {
    template: /* html */ `
      <span class="badge bg-dark rounded-pill">testing</span>
    `,
  },
};

// eslint-disable-next-line no-new
new Vue({
  el: '#app',

  data: {
    ...[...propsQuery, ...propsLocalStorage] // add all props
      .reduce((acc, { name, defaultValue }) => ({ ...acc, [name]: defaultValue }), {}),
    error: null,
    info: null,
    ready: false,
    timestampInit: null,
    timestampReady: null,
    shortcuts,
    scenarios,
  },

  components,

  created() {
    this.init();
  },

  methods: {
    async loadCSS(cssURL) {
      return new Promise((resolve) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssURL;
        link.onload = () => {
          resolve();
          console.log(`CSS ${cssURL} has loaded!`);
        };
        document.head.appendChild(link);
      });
    },

    async loadJS(jsURL) {
      return new Promise((resolve) => {
        const link = document.createElement('script');
        link.src = jsURL;
        link.onload = () => {
          resolve();
          console.log(`JS ${jsURL} has loaded!`);
        };
        document.head.appendChild(link);
      });
    },

    async loadTefOne(sp, tefOneEnv) {
      await this.loadCSS(`https://one.o9.de/${tefOneEnv}/${sp}/variables.css`);
      await this.loadCSS(`https://one.o9.de/${tefOneEnv}/${sp}/components.css`);
      await this.loadJS(`https://one.o9.de/${tefOneEnv}/bundle.js`);
    },

    async init() {
      // sets props from URL and local storage
      const search = new URLSearchParams(window.location.search);
      propsQuery.forEach(({ name, type }) => {
        const value = search.get(name);
        if (value !== null) {
          this[name] = type === 'boolean' ? value === 'true' : value;
        }
      });
      propsLocalStorage.forEach(({ name }) => {
        const value = window.localStorage.getItem(name);
        if (value !== null) {
          this[name] = JSON.parse(value);
        }
      });
      // turn on debug mode
      window.localStorage.setItem('tef-coms-4cs-debug-mode', 'true');
      // listen to some events
      document.addEventListener('tef-coms4cs', (e) => {
        const { detail } = e;
        if (detail.name === 'load/READY') {
          this.ready = true;
        }
        if (detail.name === 'load/ERROR') {
          this.setError(detail.error);
        }
      });

      if (this.tefOne) {
        await this.loadTefOne(this.tefOne, this.tefOneEnv);
      }
      // create COMS micro-frontend
      this.tefComsMicrofrontendHost = createComs(this);
    },

    reload() {
      propsLocalStorage.forEach(({ name }) => {
        window.localStorage.setItem(name, JSON.stringify(this[name]));
      });
      const search = new URLSearchParams();
      propsQuery.forEach(({ name }) => {
        search.set(name, this[name]);
      });
      window.location = `${window.location.pathname}?${search.toString()}`; // reload page
    },

    save() {
      this.tefComsMicrofrontendHost
        .save()
        .then(() => this.setInfo('Saving consents successful.'))
        .catch((error) => this.setError(error));
    },

    cancel() {
      try {
        this.tefComsMicrofrontendHost.cancel();
        this.setInfo('Cancel successful. Please recreate the micro-frontend.');
      } catch (error) {
        this.setError(error);
      }
    },

    undo() {
      this.tefComsMicrofrontendHost
        .undo()
        .then(() => this.setInfo('Undid last change'))
        .catch((error) => this.setError(error));
    },

    logConsents() {
      const consents = this.tefComsMicrofrontendHost.getConsents();
      console.log('tef-coms4cs: getConsents()', consents);
      this.setInfo('<textarea cols=120 rows=40>' + JSON.stringify(consents, null, 2) + '</textarea>');
    },

    statusConsents() {
      const consents = this.tefComsMicrofrontendHost.getConsentStatus();
      console.log('tef-coms4cs: getConsentStatus()', consents);
      this.setInfo('<textarea cols=120 rows=40>' + JSON.stringify(consents, null, 2) + '</textarea>');
    },

    showHtml() {
      const escapeHtml = (unsafe) =>
        unsafe
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      const html = document.getElementById('consents').outerHTML;
      this.setInfo(escapeHtml(html));
    },

    setScenario(value) {
      this.scenario = value;
    },

    isScenario(...value) {
      return value.includes(this.scenario);
    },

    setValue(prop, value) {
      this[prop] = value;
    },

    setInfo(text) {
      this.info = Array.isArray(text) ? text.join('<br />') : text;
      this.error = null;
    },

    setError(error) {
      this.error = error;
      if (error instanceof Error) {
        const { statusCode, statusText, stack } = error;
        const httpText = statusCode && statusText ? `<br />HTTP ${statusCode} ${statusText}` : '';
        const stackText = stack ? `<br />${stack}` : '';
        this.info = `${error.toString()}${httpText}${stackText}`;
      } else {
        this.info = error;
      }
    },
  },
});
